/*!
 * lightning-watch.js — «сообщить, когда гроза подойдёт» на /lightning-map.
 *
 * ЧТО ЭТО. Слежка за ТОЧКОЙ: координата, своё имя точки, круг 10/30/50 км и
 * «не писать ночью». Сообщения (письмо и пуш) шлёт `lightning:notify`; здесь
 * только запись, список и удаление.
 *
 * Точку человек отмечает НА КАРТЕ (нажатие или «Рядом со мной») — та же
 * точка, для которой карточка выше показывает расстояние до грозы. Карта
 * сообщает о ней событием `lightning:me`, а имя города рядом — событием
 * `lightning:place`; своего поиска города здесь нет.
 *
 * ⚠️ ЧЕСТНАЯ РАМКА. Сообщение приходит через минуты после разряда, и спутник
 * видит не каждую вспышку. Строка `watch_honest` стоит в разметке всегда и не
 * зависит ни от слежек, ни от тарифа.
 *
 * ⚠️ Блок виден всем, включая гостей и аккаунты без Премиума: кнопка у них
 * ведёт ко входу или в Премиум, а не притворяется рабочей.
 */
(function () {
    'use strict';

    var C = window.LIGHTNING_CFG || {};
    var T = C.t || {};
    var API = (C.api && C.api.watch) || '/api/lightning-watch';
    var SLUG = 'lightning-map';
    var tr = function (k) { return T[k] != null ? T[k] : k; };
    var $ = function (id) { return document.getElementById(id); };
    var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
    var toast = function (msg, type) { if (window.__toast) window.__toast(msg, type || 'warning'); };

    var esc = function (s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    };

    var root = $('lmWatch');
    if (!root) return;

    var picked = null;          // {lat, lon} — точка с карты
    var nameAuto = '';          // имя, подставленное нами; набранное человеком не трогаем
    /* `authed` — от сервера при рендере (LIGHTNING_CFG.authed), а не «false,
     * пока fetch не ответил»: медленный или упавший запрос иначе делает из
     * вошедшего гостя и уводит его на /login. Кука входа старше разметки —
     * разметка может быть копией из кэша (см. __signedIn в timbrica-core.js). */
    var state = { premium: false, max: 3, watches: [],
                  authed: C.authed === true || (typeof window.__signedIn === 'function' && window.__signedIn()) };

    function csrf() {
        var m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : '';
    }

    function premiumUrl() {
        // __PRO_URL знает дверь и для гостя, и для вошедшего.
        return window.__PRO_URL || ('/' + (window.__LOCALE || 'en') + '/pricing');
    }

    function mapApi() { return window.__lightningMap || null; }

    /* ── Список ────────────────────────────────────────────────────────── */

    function load() {
        fetch(API, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) {
                // 401 — это гость, а не поломка: блок остаётся видимым.
                if (r.status === 401) { state.authed = false; return null; }
                state.authed = true;
                return r.ok ? r.json() : null;
            })
            .then(function (d) {
                if (d) {
                    state.premium = !!d.premium;
                    state.max = d.max || 3;
                    state.watches = d.watches || [];
                }
                render();
            })
            .catch(render);
    }

    function render() {
        var list = $('lmWList'), note = $('lmWNote');
        if (!list) return;

        list.innerHTML = state.watches.map(function (w) {
            var sub = w.radius_km + ' ' + tr('km')
                + (w.quiet_night ? ' · ' + tr('watch_night_short') : '')
                + (w.edge ? ' · ' + tr('watch_edge') : '');
            return '<li><button type="button" class="lm-watch-go" data-go="' + w.id + '"><b>' + esc(w.place) + '</b><small>' + esc(sub) + '</small></button>'
                 + '<button type="button" class="lm-watch-del" data-del="' + w.id + '">' + esc(tr('watch_remove')) + '</button></li>';
        }).join('');

        var m = mapApi();
        if (m && m.setWatches) m.setWatches(state.watches);

        if (note) {
            if (!state.authed) {
                note.textContent = tr('watch_login');
            } else if (!state.premium) {
                note.innerHTML = esc(tr('watch_premium')) + ' <a href="' + esc(premiumUrl()) + '">' + esc(tr('watch_premium_cta')) + '</a>';
            } else if (state.watches.length >= state.max) {
                note.textContent = tr('watch_limit').replace(':max', state.max);
            } else {
                note.textContent = '';
            }
        }
        renderPush();
    }

    /* ── Точка с карты ─────────────────────────────────────────────────── */

    function setPicked(lat, lon) {
        picked = { lat: lat, lon: lon };
        var out = $('lmWPoint'), input = $('lmWPlace');
        if (out) {
            // Координаты читаются слева направо и в арабской раскладке: без своей
            // изоляции строка «4.61° N, 74.08° W» переставляется по кускам.
            var span = document.createElement('span');
            span.dir = 'ltr';
            span.textContent = Math.abs(lat).toFixed(2) + '° ' + (lat >= 0 ? 'N' : 'S') + ', ' + Math.abs(lon).toFixed(2) + '° ' + (lon >= 0 ? 'E' : 'W');
            out.textContent = '';
            out.appendChild(span);
        }
    }

    /* Имя по умолчанию — город рядом на языке страницы; его находит карта
       (общий набор городов) и сообщает событием. Набранное человеком не трогаем. */
    document.addEventListener('lightning:place', function (e) {
        var d = e.detail || {}, input = $('lmWPlace');
        if (!input || !d.name || !picked || Math.abs(d.lat - picked.lat) > 1e-6 || Math.abs(d.lon - picked.lon) > 1e-6) return;
        if (input.value.trim() === '' || input.value === nameAuto) { input.value = d.name; nameAuto = d.name; }
    });

    document.addEventListener('lightning:me', function (e) {
        var d = e.detail || {};
        if (typeof d.lat === 'number' && typeof d.lon === 'number') setPicked(d.lat, d.lon);
    });

    /* ── Запись и удаление ─────────────────────────────────────────────── */

    function wireAdd() {
        var btn = $('lmWAdd');
        if (!btn) return;
        btn.addEventListener('click', function () {
            // Дверь, а не тупик: кто упёрся в неё и в какую — видно в телеметрии
            // (за первую неделю у слежки не было ни одного события), а отмеченная
            // точка едет через вход в якоре и встаёт на карту сама.
            if (!state.authed) {
                ae('feature_use', { slug: SLUG, feature: 'watch_gate', gate: 'login' });
                var back = location.pathname + (picked ? '#p=' + picked.lat.toFixed(4) + ',' + picked.lon.toFixed(4) : '');
                window.location.href = '/' + (window.__LOCALE || 'en') + '/login?redirect=' + encodeURIComponent(back);
                return;
            }
            if (!state.premium) {
                ae('feature_use', { slug: SLUG, feature: 'watch_gate', gate: 'premium' });
                window.location.href = premiumUrl();
                return;
            }
            if (!picked) { toast(tr('watch_pick_first')); return; }

            var input = $('lmWPlace');
            var place = (input && input.value.trim()) || $('lmWPoint').textContent;
            btn.disabled = true;
            fetch(API, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({
                    lat: picked.lat, lng: picked.lon, place: place,
                    radius_km: Number($('lmWRadius').value),
                    quiet_night: $('lmWNight').checked
                })
            })
                .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
                .then(function (res) {
                    if (!res.ok) {
                        // Отказ обязан быть назван: молчащая кнопка — «клик в пустоту».
                        var code = (res.d && res.d.error) || '';
                        if (code === 'premium_required') { window.location.href = premiumUrl(); return; }
                        toast(code === 'watch_limit' ? tr('watch_limit').replace(':max', res.d.max)
                            : code === 'no_coverage' ? tr('watch_no_coverage')
                            : code === 'bad_settings' || code === 'invalid_point' ? tr('watch_bad')
                            : tr('watch_error'));
                        return;
                    }
                    state.watches.push(res.d.watch);
                    if (input) { input.value = ''; nameAuto = ''; }
                    render();
                    toast(tr('watch_added'), 'success');
                    ae('feature_use', { slug: SLUG, feature: 'watch_add' });
                })
                .catch(function () { toast(tr('watch_error')); })
                .then(function () { btn.disabled = false; });
        });
    }

    function wireList() {
        var list = $('lmWList');
        if (!list) return;
        list.addEventListener('click', function (e) {
            var go = e.target.closest('button[data-go]');
            if (go) {
                var w = state.watches.filter(function (x) { return String(x.id) === String(go.dataset.go); })[0];
                var m = mapApi();
                if (w && m && m.focus) m.focus(w.lat, w.lng);
                return;
            }
            var b = e.target.closest('button[data-del]');
            if (!b) return;
            var id = b.dataset.del;
            b.disabled = true;
            fetch(API + '/' + encodeURIComponent(id), {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: { 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' }
            })
                .then(function (r) {
                    if (!r.ok) throw new Error('http ' + r.status);
                    state.watches = state.watches.filter(function (w) { return String(w.id) !== String(id); });
                    render();
                    ae('feature_use', { slug: SLUG, feature: 'watch_remove' });
                })
                .catch(function () { b.disabled = false; toast(tr('watch_error')); });
        });
    }

    /* ── Пуш: сообщение о грозе в письме опаздывает на минуты сильнее ───── */

    function renderPush() {
        var row = $('lmWPush'), msg = $('lmWPushMsg'), btn = $('lmWPushBtn'), push = window.__timbricaPush;
        if (!row || !push || !push.state) return;
        // Предлагаем только тому, у кого слежка уже есть: до неё пуш ни о чём.
        if (!state.premium || !state.watches.length) { row.hidden = true; return; }
        push.state().then(function (s) {
            // «Заблокировано в настройках браузера» отсюда не исправить — молчим.
            if (s === 'unsupported' || s === 'blocked') { row.hidden = true; return; }
            row.hidden = false;
            if (s === 'subscribed') { msg.textContent = tr('watch_push_on'); btn.hidden = true; }
            else { msg.textContent = tr('watch_push_offer'); btn.hidden = false; }
        }).catch(function () { row.hidden = true; });
    }

    function wirePush() {
        var btn = $('lmWPushBtn');
        if (!btn) return;
        btn.addEventListener('click', function () {
            var push = window.__timbricaPush;
            if (!push || !push.subscribe) return;
            btn.disabled = true;
            push.subscribe()
                .then(function () { ae('feature_use', { slug: SLUG, feature: 'watch_push_on' }); })
                .catch(function () { toast(tr('watch_push_failed')); })
                .then(function () { btn.disabled = false; renderPush(); });
        });
    }

    wireAdd();
    wireList();
    wirePush();
    // Точка могла быть выбрана раньше, чем загрузился этот файл.
    var m0 = mapApi(), me0 = m0 && m0.me ? m0.me() : null;
    if (me0) {
        setPicked(me0.lat, me0.lon);
        if (me0.place && $('lmWPlace') && !$('lmWPlace').value) { $('lmWPlace').value = me0.place; nameAuto = me0.place; }
    }
    load();
}());
